const formGenerateRegisterInfo = [
  {
    label: "STUDENT_MANAGEMENT.FORM.REGISTER.DEGREE_LABEL",
    name: "dregree",
    placeholder: "STUDENT_MANAGEMENT.FORM.REGISTER.DEGREE_PLACEHOLDER",
    type: "select",
    typeForm: "select",
    formSize: "small",
    optionName: "degree",
    style: {},
    responsive: { sm: 12, md: 2, lg: 2 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.REGISTER.DEGREE_REQUIRED",
    disable: true,
    section: "register",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.REGISTER.FACULTY_LABEL",
    name: "faculty",
    placeholder: "STUDENT_MANAGEMENT.FORM.REGISTER.FACULTY_PLACEHOLDER",
    type: "select",
    typeForm: "select",
    formSize: "small",
    optionName: "faculty",
    style: {},
    responsive: { sm: 12, md: 4, lg: 4 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.REGISTER.FACULTY_REQUIRED",
    disable: true,
    section: "register",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.REGISTER.EDUCATION_YEAR_LABEL",
    name: "education_year",
    placeholder: "STUDENT_MANAGEMENT.FORM.REGISTER.EDUCATION_YEAR_PLACEHOLDER",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "currency",
    style: {},
    responsive: { sm: 12, md: 2, lg: 2 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.REGISTER.EDUCATION_YEAR_REQUIRED",
    disable: true,
    section: "register",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.REGISTER.CURRENT_EMAIL_LABEL",
    name: "current_email",
    placeholder: "STUDENT_MANAGEMENT.FORM.REGISTER.CURRENT_EMAIL_PLACEHOLDER",
    type: "input",
    typeForm: "email",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 4, lg: 4 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.REGISTER.CURRENT_EMAIL_REQUIRED",
    disable: true,
    section: "register",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.REGISTER.YEAR_STUDY_LABEL",
    name: "year_study",
    placeholder: "STUDENT_MANAGEMENT.FORM.REGISTER.YEAR_STUDY_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 2, lg: 2 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.REGISTER.YEAR_STUDY_REQUIRED",
    disable: true,
    section: "register",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.REGISTER.DATE_COMMENCEMENT_STUDIE_LABEL",
    name: "data_commencement_studie",
    placeholder:
      "STUDENT_MANAGEMENT.FORM.REGISTER.DATE_COMMENCEMENT_STUDIE_PLACEHOLDER",
    type: "date",
    typeForm: "date",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 4, lg: 4 },
    isRequired: true,
    titleRequired:
      "STUDENT_MANAGEMENT.FORM.REGISTER.DATE_COMMENCEMENT_STUDIE_REQUIRED",
    disable: false,
    section: "register",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.REGISTER.STUDENT_ID_NUMBER_LABEL",
    name: "student_id_number",
    placeholder:
      "STUDENT_MANAGEMENT.FORM.REGISTER.STUDENT_ID_NUMBER_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 2, lg: 2 },
    isRequired: true,
    titleRequired:
      "STUDENT_MANAGEMENT.FORM.REGISTER.STUDENT_ID_NUMBER_REQUIRED",
    disable: false,
    section: "register",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.REGISTER.STUDENT_EMAIL_LABEL",
    name: "student_email",
    placeholder: "STUDENT_MANAGEMENT.FORM.REGISTER.STUDENT_EMAIL_PLACEHOLDER",
    type: "input",
    typeForm: "email",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 4, lg: 4 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.REGISTER.STUDENT_EMAIL_REQUIRED",
    disable: false,
    section: "register",
  },

  // Add more fields as needed
];

export default formGenerateRegisterInfo;
